import axios from '@axios';

// Los blogs viajan con imagen, así que create/update usan FormData.
// Las etiquetas son un array: se serializan como JSON para no perder los
// nombres que llevan comas.
const buildFormData = (payload) => {

    let formData = new FormData();

    formData.append('image', payload.image);

    Object.entries(payload).map(item => {

        if (item[0] === 'image') return;

        if (item[0] === 'tags') {
            formData.append('tags', JSON.stringify(item[1] || []));
            return;
        }

        formData.append(item[0], item[1]);

    });

    return formData;

};

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchBlogs(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/blogs', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchSelectOptions() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/blogs/select')
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchBlog(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/blog/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        createBlog(ctx, { payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/blog/create', buildFormData(payload), {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        updateBlog(ctx, { id, payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/blog/${id}/update`, buildFormData(payload), {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        publishBlog(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/blog/${id}/publish`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        hideBlog(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/blog/${id}/hide`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        deleteBlog(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/blog/${id}/delete`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}
